// Network to theme mapping utility
export const NETWORK_THEME_MAPPING = {
  // BSC Networks
  56: 'BSCChain',      // BSC Mainnet
  97: 'BSCChain',      // BSC Testnet
  204: 'BSCChain',     // opBNB Mainnet
  5611: 'BSCChain',    // opBNB Testnet
  
  // Ethereum Networks  
  1: 'ETH',            // Ethereum Mainnet
  11155111: 'ETH',     // Sepolia Testnet
  
  // Avalanche Networks
  43114: 'AVX',        // Avalanche Mainnet
  43113: 'AVX',        // Avalanche Fuji Testnet
  
  // Abstract Networks
  2741: 'Abstract',    // Abstract Mainnet
  11124: 'Abstract',   // Abstract Sepolia Testnet
  
  // Base Networks
  8453: 'Base',        // Base Mainnet
  84532: 'Base',       // Base Sepolia Testnet
  
  // Polygon Networks
  137: 'Poly',         // Polygon Mainnet
  80002: 'Poly',       // Polygon Amoy Testnet
  
  // OP Networks
  10: 'OP',            // OP Mainnet
  11155420: 'OP',      // OP Sepolia Testnet
  
  // Arbitrum Networks (using King Blue as requested)
  42161: 'King Blue',  // Arbitrum One
  421614: 'King Blue', // Arbitrum Sepolia Testnet
  
  // Sei Networks
  1329: 'Blade',       // Sei Mainnet
  1328: 'Blade',       // Sei Atlantic-2 Testnet
} as const;

export type NetworkId = keyof typeof NETWORK_THEME_MAPPING;
export type ThemeName = typeof NETWORK_THEME_MAPPING[NetworkId];

/**
 * Get the theme name for a given network/chain ID
 */
export function getThemeForNetwork(chainId: number): string | null {
  return NETWORK_THEME_MAPPING[chainId as NetworkId] || null;
}

/**
 * Check if automatic theme switching is enabled
 */
export function isAutoThemeSwitchEnabled(): boolean {
  return localStorage.getItem('autoThemeSwitch') !== 'false';
}

/**
 * Enable or disable automatic theme switching
 */
export function setAutoThemeSwitchEnabled(enabled: boolean): void {
  localStorage.setItem('autoThemeSwitch', enabled.toString());
}
